import {
  EqlFieldMetadataReference,
  EqlFieldValueType,
  MetadataDataType,
} from 'generated/graphql';
import { SelectedMetadataFields } from '../types';
import { mapMetaDataTypeToEQLFieldValueType } from './mapMetaDataTypeToEQLFieldValueType';

export const mapEQLReferenceToSelectedMetadata = (
  eqlReferences: EqlFieldMetadataReference[] | undefined,
  unifiedFieldType: MetadataDataType | undefined,
): SelectedMetadataFields => {
  if (!eqlReferences) {
    return [];
  }
  return eqlReferences.map((eqlReference) => ({
    id: `${eqlReference.key}-${eqlReference.source}`,
    label: eqlReference.displayName,
    field: eqlReference.key,
    source: eqlReference.source,
    sourceIconURL: eqlReference.iconURL,
    type:
      mapMetaDataTypeToEQLFieldValueType(unifiedFieldType) ??
      EqlFieldValueType.None,
    sampleValues: [],
  }));
};
